<template>
  <v-dialog v-model="internalValue" max-width="950px" scrollable>
    <v-card class="rounded-xl overflow-hidden">
      <!-- Toolbar Neutro -->
      <v-toolbar color="grey darken-3" dark flat dense>
        <v-icon left small>mdi-certificate</v-icon>
        <v-toolbar-title class="text-subtitle-2 font-weight-bold text-uppercase">
          Certificado de Capacitación (Plantilla Provisional)
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="amber darken-3"
          dark
          small
          class="font-weight-bold mr-2 text-none"
          elevation="0"
          :loading="generatingPdf"
          @click="downloadCertificate"
        >
          <v-icon left small>mdi-printer</v-icon>
          Imprimir / Descargar Certificado
        </v-btn>
        <v-btn icon small @click="internalValue = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-4 bg-grey-lighten-4" style="max-height: 75vh;">
        <!-- Conversor HTML2PDF Formato Horizontal Landscape -->
        <vue-html2pdf
          :show-layout="true"
          :float-layout="false"
          :enable-download="true"
          :preview-modal="false"
          :filename="certificateFileName"
          :paginate-elements-by-height="1100"
          :pdf-quality="2"
          pdf-format="a4"
          pdf-orientation="landscape"
          pdf-content-width="1000px"
          :manual-pagination="true"
          :margin="0"
          :htmlToPdfOptions="htmlToPdfOptions"
          ref="certificatePdf"
        >
          <section slot="pdf-content">
            <div class="certificate-container">
              <div class="cert-outer-border">
                <div class="cert-inner-border">
                  <!-- Marca de Agua de Fondo Sutil -->
                  <div class="cert-watermark">
                    <img src="/static/logo_sp.png" alt="Watermark" class="watermark-img" />
                  </div>

                  <!-- Contenido del Certificado -->
                  <div class="cert-content">
                    <!-- Logo Encabezado -->
                    <div class="cert-header">
                      <img src="/static/logo_sp.png" alt="Sunshine Logo" class="cert-logo" />
                      <div class="cert-company-name">SUNSHINE EXPORT S.A.C.</div>
                      <div class="cert-sub-org">Sistema Integrado de Gestión - Seguridad, Salud y Talento Humano</div>
                    </div>

                    <!-- Título -->
                    <div class="cert-main-title">
                      CERTIFICADO
                    </div>
                    <div class="cert-title-sub">
                      DE PARTICIPACIÓN Y APROBACIÓN
                    </div>

                    <!-- Texto de Otorgamiento -->
                    <div class="cert-intro">
                      Se otorga el presente reconocimiento a:
                    </div>

                    <!-- Nombre del Participante -->
                    <div class="cert-student-name">
                      {{ participantData.ParticipantFullName || participantData.PrsFullName || 'Nombre del Colaborador' }}
                    </div>

                    <!-- Documento y Cargo -->
                    <div class="cert-student-meta">
                      Documento de Identidad (DNI): <b>{{ participantData.PrsDocumentNumber || '-' }}</b>
                      <span v-if="participantData.PstName"> &nbsp;|&nbsp; Cargo: <b>{{ participantData.PstName }}</b></span>
                      <span v-if="participantData.AreName"> &nbsp;|&nbsp; Área: <b>{{ participantData.AreName }}</b></span>
                    </div>

                    <!-- Detalle del Curso -->
                    <div class="cert-body-text">
                      Por haber completado y aprobado satisfactoriamente el curso / evento de capacitación:
                    </div>

                    <div class="cert-course-title">
                      "{{ eventData.TevName || participantData.TevName || 'Curso de Capacitación y Entrenamiento' }}"
                    </div>

                    <div class="cert-details">
                      Modalidad: <b>{{ eventData.TypeModalityName || 'Presencial' }}</b> &nbsp;&bull;&nbsp;
                      Duración: <b>{{ eventData.TevTotalHours ? eventData.TevTotalHours + ' Horas Académicas' : 'Completado' }}</b> &nbsp;&bull;&nbsp;
                      Fecha: <b>{{ formatDate(eventData.TevDateInitial || participantData.SecCreate) }}</b>
                    </div>

                    <!-- Firmas Inferiores -->
                    <div class="cert-signatures">
                      <div class="sig-box">
                        <div class="sig-line"></div>
                        <div class="sig-name">{{ eventData.TrnFullName || 'Capacitador / Facilitador' }}</div>
                        <div class="sig-role">Instructor Especialista</div>
                      </div>

                      <div class="sig-seal-box">
                        <div class="cert-seal">
                          <v-icon color="amber darken-3" large>mdi-shield-check</v-icon>
                          <div class="seal-text">COMPLIANCE SST</div>
                        </div>
                      </div>

                      <div class="sig-box">
                        <div class="sig-line"></div>
                        <div class="sig-name">Jefatura de Talento Humano / SST</div>
                        <div class="sig-role">Sunshine Export S.A.C.</div>
                      </div>
                    </div>

                    <!-- Footer / Verificación -->
                    <div class="cert-footer-meta">
                      Código de Registro: SUN-CERT-{{ participantData.TpaID || '000' }}-{{ (eventData.TevID || 0) }} &nbsp;|&nbsp; Piura, Perú
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </vue-html2pdf>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="py-3 px-4 bg-white d-flex justify-end">
        <v-btn text color="grey darken-2" @click="internalValue = false">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";

export default {
  name: "TrainingCertificateModal",
  components: {
    VueHtml2pdf,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    participant: {
      type: Object,
      default: () => ({}),
    },
    event: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      generatingPdf: false,
      htmlToPdfOptions: {
        margin: [5, 5, 5, 5],
        filename: "Certificado_Capacitacion.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, logging: false },
        jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
      },
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    participantData() {
      return this.participant || {};
    },
    eventData() {
      return this.event || {};
    },
    certificateFileName() {
      const name = (this.participantData.ParticipantFullName || "Participante")
        .replace(/[^a-zA-Z0-9_-]/g, "_")
        .substring(0, 25);
      return `Certificado_${name}.pdf`;
    },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "__/__/____";
      const parts = String(dateStr).split("T")[0].split("-");
      if (parts.length === 3) {
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }
      return dateStr;
    },
    downloadCertificate() {
      this.generatingPdf = true;
      if (this.$refs.certificatePdf) {
        this.$refs.certificatePdf.generatePdf();
      }
      setTimeout(() => {
        this.generatingPdf = false;
      }, 2500);
    },
  },
};
</script>

<style scoped>
.certificate-container {
  width: 980px;
  height: 690px;
  background-color: #ffffff;
  padding: 15px;
  box-sizing: border-box;
  font-family: 'Times New Roman', Times, serif;
  color: #1a1a1a;
  position: relative;
}

.cert-outer-border {
  border: 4px double #2c3e50;
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.cert-inner-border {
  border: 1px solid #d4af37;
  height: 100%;
  padding: 20px 35px;
  box-sizing: border-box;
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.cert-watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.05;
  pointer-events: none;
}

.watermark-img {
  width: 450px;
  height: auto;
}

.cert-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.cert-header {
  margin-bottom: 5px;
}

.cert-logo {
  height: 48px;
  width: auto;
  margin-bottom: 4px;
}

.cert-company-name {
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 2px;
  color: #1e293b;
  font-family: Arial, Helvetica, sans-serif;
}

.cert-sub-org {
  font-size: 9px;
  color: #64748b;
  font-family: Arial, Helvetica, sans-serif;
}

.cert-main-title {
  font-size: 32px;
  font-weight: 900;
  letter-spacing: 6px;
  color: #1e3a8a;
  margin-top: 5px;
}

.cert-title-sub {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  color: #b45309;
  font-family: Arial, Helvetica, sans-serif;
}

.cert-intro {
  font-size: 13px;
  font-style: italic;
  color: #475569;
  margin-top: 10px;
}

.cert-student-name {
  font-size: 24px;
  font-weight: bold;
  color: #0f172a;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 1.5px solid #d4af37;
  display: inline-block;
  margin: 5px auto;
  padding: 0 25px 4px 25px;
}

.cert-student-meta {
  font-size: 10px;
  color: #64748b;
  font-family: Arial, Helvetica, sans-serif;
}

.cert-body-text {
  font-size: 12px;
  color: #334155;
  margin-top: 10px;
}

.cert-course-title {
  font-size: 18px;
  font-weight: bold;
  color: #1e3a8a;
  margin: 5px 0;
}

.cert-details {
  font-size: 10.5px;
  color: #64748b;
  font-family: Arial, Helvetica, sans-serif;
}

.cert-signatures {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 20px;
  padding: 0 40px;
}

.sig-box {
  width: 230px;
  text-align: center;
}

.sig-line {
  border-top: 1px solid #1e293b;
  margin-bottom: 6px;
}

.sig-name {
  font-size: 11px;
  font-weight: bold;
  color: #1e293b;
  font-family: Arial, Helvetica, sans-serif;
}

.sig-role {
  font-size: 9px;
  color: #64748b;
  font-family: Arial, Helvetica, sans-serif;
}

.sig-seal-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cert-seal {
  border: 2px dashed #d97706;
  border-radius: 50%;
  width: 75px;
  height: 75px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4px;
}

.seal-text {
  font-size: 7px;
  font-weight: bold;
  color: #92400e;
  letter-spacing: 0.5px;
  font-family: Arial, Helvetica, sans-serif;
}

.cert-footer-meta {
  font-size: 8px;
  color: #94a3b8;
  font-family: Arial, Helvetica, sans-serif;
  margin-top: 15px;
}
</style>
